import { combineReducers } from "redux";
import form from "./forms";
import activeTab from "./activeTab";
import popupOpen from "./popup";
import categories from "./categories";
import user from "./user";

export default combineReducers({
    form, activeTab, popupOpen, categories, user, 
})